export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvSlider.vue?vue&type=template&id=702a3cdb&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvSlider.vue?vue&type=template&id=702a3cdb&lang=pug&
// module id = 164
// module chunks = 0 1